/**
 * viewing-over-time-by-devices-trend-chart
 *
 * @author    Andy Lowe <andy.lowe@mediatel.co.uk>
 * @copyright 2019 Mediatel Limited.
 */

"use strict";

import "babel-polyfill";
import coreFactory from "./common/core";
import sandboxFactory from "./common/sandbox";

// Modules:
import moreInfo from "./top-programmes/more-info";
import weeklyViewingLevels from "./tv-player-report/viewing-over-time-by-devices-trend-chart-open";
import streamsSelectFactory from "./tv-player-report/streams-select";
import devicesSelectFactory from "./tv-player-report/devices-select-open";
import weeklyPeriodSelectsFactory from "./tv-player-report/weekly-period-selects";

const core = coreFactory(window.jQuery, sandboxFactory);

core.createModule('streams_select', streamsSelectFactory({
    labelAll: 'All viewing'
}));
core.createModule('devices_select', devicesSelectFactory);
core.createModule(
    "startPeriodSelects",
    weeklyPeriodSelectsFactory('tv-player-report/get-available-weeks', {
        type: 'tvpr_weekly_viewing_oogid',
        datePartIds: ['start_period_year', 'start_period_month', 'start_period_week'],
        startMonthsFromEnd: 12,
        weeksInterval: 1
    })
);
core.createModule(
    "endPeriodSelects",
    weeklyPeriodSelectsFactory('tv-player-report/get-available-weeks', {
        type: 'tvpr_weekly_viewing_oogid',
        datePartIds: ["end_period_year", "end_period_month", "end_period_week"],
        weeksInterval: 1
    })
);
core.createModule('weekly_viewing_levels', weeklyViewingLevels(
    'tv-player-report/viewing-over-time-by-devices-trend-chart',
    {
        chart: {
            xLabel: '',
            yLabel: 'Weekly viewing levels (total minutes played)',
            errorMessage: 'No data for this combination of broadcasters'
        },
        csv: {
            filename: 'Viewing-Over-Time-By-Devices-Trend-Chart.csv'
        }
    }
));

core.createModule("moreInfo", moreInfo);

core.startAll();